import * as React from 'react';
import { errorHandler } from '../../../error/handler';
import { getUso, getUsoList } from '../../../fetch/lotto/attributes/uso';
import { IUso } from '../../../interfaces/lotto/attributes/models';
import { normalizer } from '../../../lib/normalizer';
import { useAppDispatch } from '../../../store/hooks';
import { emptyAction, getAction, listAction } from '../../../store/lotto/attributes/uso/actions';
import { IUsoState } from '../../../store/lotto/attributes/uso/types';
import { endActionToDoAction, startActionToDoAction } from '../../../store/ui/actions';

export const useGetUso = (id: number) => {
	const dispatch = useAppDispatch();
	React.useEffect(() => {
		const effect = async () => {
			if (!id) return;
			const actionToDo = 'get-uso';
			try {
				dispatch(startActionToDoAction({ actionToDo }));
				const uso = await getUso(id);
				dispatch(getAction(uso));
				dispatch(endActionToDoAction({ actionToDo, success: true }));
			} catch (err) {
				errorHandler(err, actionToDo);
			}
		}
		effect();
	}, [dispatch, id])
}

export const useUsoList = (query: number) => {
	const dispatch = useAppDispatch();
	React.useEffect(() => {
		const effect = async () => {
			if (!query) return;
			const actionToDo = 'list-uso';
			try {
				dispatch(startActionToDoAction({ actionToDo }));
				const { results, items: _items } = await getUsoList();
				_items.sort((itemA, itemB) => (!!itemA?.ordinamento && !!itemB.ordinamento) ? itemA.ordinamento - itemB.ordinamento : 0);
				const { list, items } = normalizer<number, IUso>(_items, "id");
				const actionPayload: IUsoState = {
					results,
					list,
					items
				}
				dispatch(listAction(actionPayload));
				dispatch(endActionToDoAction({ actionToDo, success: true }));
			} catch (err) {
				errorHandler(err, actionToDo);
			}
			return () => {
				dispatch(emptyAction());
			}
		}
		effect();
	}, [dispatch, query])
}
